export function Ratio1x1Icon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="2.5" y="2.5" width="15" height="15" rx="2" stroke="currentColor" stroke-width="1.6625" />
    </svg>
  );
}

Ratio1x1Icon.displayName = 'Ratio1x1Icon';
